import React from 'react';

const LoadingSkeleton = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="content-container pt-4">
        <div className="container mx-auto px-4 py-8">
          {/* Breadcrumb Skeleton */}
          <div className="mb-6">
            <div className="flex items-center space-x-2">
              <div className="h-4 bg-secondary-200 rounded w-12 animate-pulse"></div>
              <div className="h-4 bg-secondary-200 rounded w-4 animate-pulse"></div>
              <div className="h-4 bg-secondary-200 rounded w-12 animate-pulse"></div>
              <div className="h-4 bg-secondary-200 rounded w-4 animate-pulse"></div>
              <div className="h-4 bg-secondary-200 rounded w-32 animate-pulse"></div>
            </div>
          </div>

          {/* Header Skeleton */}
          <div className="flex flex-wrap items-center gap-6 mb-8">
            {/* Company Logo Skeleton */}
            <div className="w-20 h-20 rounded-xl bg-secondary-200 animate-pulse flex-shrink-0"></div>
            
            {/* Job Info Skeleton */}
            <div className="flex-1 min-w-0">
              <div className="h-8 bg-secondary-200 rounded w-3/4 mb-3 animate-pulse"></div>
              <div className="flex items-center space-x-4 mb-4">
                <div className="h-5 bg-secondary-200 rounded w-32 animate-pulse"></div>
                <div className="h-5 bg-secondary-200 rounded w-24 animate-pulse"></div>
                <div className="h-6 bg-secondary-200 rounded-full w-16 animate-pulse"></div>
              </div>
              <div className="flex flex-wrap items-center gap-4">
                <div className="h-4 bg-secondary-200 rounded w-20 animate-pulse"></div>
                <div className="h-4 bg-secondary-200 rounded w-24 animate-pulse"></div>
                <div className="h-4 bg-secondary-200 rounded w-28 animate-pulse"></div>
                <div className="h-4 bg-secondary-200 rounded w-24 animate-pulse"></div>
              </div>
            </div>

            {/* Action Buttons Skeleton */}
            <div className="flex items-center space-x-3">
              <div className="text-right hidden lg:block">
                <div className="h-8 bg-secondary-200 rounded w-24 mb-1 animate-pulse"></div>
                <div className="h-4 bg-secondary-200 rounded w-20 animate-pulse"></div>
              </div>
              <div className="w-12 h-12 bg-secondary-200 rounded-lg animate-pulse"></div>
              <div className="w-12 h-12 bg-secondary-200 rounded-lg animate-pulse"></div>
              <div className="w-28 h-12 bg-secondary-200 rounded-lg animate-pulse"></div>
            </div>
          </div>

          {/* Mobile Salary Skeleton */}
          <div className="lg:hidden mt-6 pt-6 border-t border-border mb-8">
            <div className="text-center">
              <div className="h-8 bg-secondary-200 rounded w-32 mx-auto mb-2 animate-pulse"></div>
              <div className="h-4 bg-secondary-200 rounded w-20 mx-auto animate-pulse"></div>
            </div>
          </div>

          {/* Content Grid Skeleton */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content Skeleton */}
            <div className="lg:col-span-2 space-y-8">
              {/* Job Description Skeleton */}
              <div className="bg-surface rounded-lg border border-border p-6">
                <div className="h-6 bg-secondary-200 rounded w-40 mb-4 animate-pulse"></div>
                <div className="space-y-3">
                  <div className="h-4 bg-secondary-200 rounded w-full animate-pulse"></div>
                  <div className="h-4 bg-secondary-200 rounded w-5/6 animate-pulse"></div>
                  <div className="h-4 bg-secondary-200 rounded w-4/5 animate-pulse"></div>
                  <div className="h-4 bg-secondary-200 rounded w-full animate-pulse"></div>
                  <div className="h-4 bg-secondary-200 rounded w-3/4 animate-pulse"></div>
                </div>
              </div>

              {/* Requirements Skeleton */}
              <div className="bg-surface rounded-lg border border-border p-6">
                <div className="h-6 bg-secondary-200 rounded w-32 mb-4 animate-pulse"></div>
                <div className="space-y-4">
                  <div>
                    <div className="h-5 bg-secondary-200 rounded w-28 mb-2 animate-pulse"></div>
                    <div className="flex flex-wrap gap-2">
                      <div className="h-8 bg-secondary-200 rounded-full w-16 animate-pulse"></div>
                      <div className="h-8 bg-secondary-200 rounded-full w-20 animate-pulse"></div>
                      <div className="h-8 bg-secondary-200 rounded-full w-18 animate-pulse"></div>
                    </div>
                  </div>
                  <div>
                    <div className="h-5 bg-secondary-200 rounded w-24 mb-2 animate-pulse"></div>
                    <div className="space-y-2">
                      <div className="h-4 bg-secondary-200 rounded w-full animate-pulse"></div>
                      <div className="h-4 bg-secondary-200 rounded w-4/5 animate-pulse"></div>
                      <div className="h-4 bg-secondary-200 rounded w-3/4 animate-pulse"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar Skeleton */}
            <div className="space-y-8">
              {/* Company Info Skeleton */}
              <div className="bg-surface rounded-lg border border-border p-6">
                <div className="h-6 bg-secondary-200 rounded w-36 mb-4 animate-pulse"></div>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 bg-secondary-200 rounded-lg animate-pulse"></div>
                  <div className="flex-1">
                    <div className="h-5 bg-secondary-200 rounded w-32 mb-2 animate-pulse"></div>
                    <div className="h-4 bg-secondary-200 rounded w-24 animate-pulse"></div>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="h-4 bg-secondary-200 rounded w-full animate-pulse"></div>
                  <div className="h-4 bg-secondary-200 rounded w-4/5 animate-pulse"></div>
                  <div className="h-4 bg-secondary-200 rounded w-3/4 animate-pulse"></div>
                </div>
              </div>

              {/* Similar Jobs Skeleton */}
              <div className="bg-surface rounded-lg border border-border p-6">
                <div className="h-6 bg-secondary-200 rounded w-28 mb-4 animate-pulse"></div>
                <div className="space-y-4">
                  {[...Array(3)].map((_, i) => (
                    <div key={i} className="border border-border rounded-lg p-4">
                      <div className="h-5 bg-secondary-200 rounded w-3/4 mb-2 animate-pulse"></div>
                      <div className="h-4 bg-secondary-200 rounded w-1/2 mb-2 animate-pulse"></div>
                      <div className="h-4 bg-secondary-200 rounded w-20 animate-pulse"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;